import { render } from "./SecondSteps.component.vue?vue&type=template&id=ad5bce8a"
import script from "./SecondSteps.component.vue?vue&type=script&lang=js"
export * from "./SecondSteps.component.vue?vue&type=script&lang=js"

import "./SecondSteps.component.vue?vue&type=style&index=0&id=ad5bce8a&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn});
